<div class="dx-card d-inline-flex flex-column" [ngStyle]="{ minWidth: '300px' }">
  <div class="dx-fieldset np-form-control">
    <div class="d-flex gap-4">
      <div>
        <div class="card-logo">
          <img src="{{ model.thumbUri }}?{{ cacheBuster }}" alt="Logo" *ngIf="model.thumbUri; else placeholderLogo" />
          <ng-template #placeholderLogo>
            <span class="glyphicon glyphicon-picture"></span>
          </ng-template>
        </div>
      </div>
      <div class="flex-grow-1 mb-3">
        <div class="dx-fieldset-header mb-2">
          <div class="inputWithPlaceHolder w-100">
            <label class="placeLabel{{ model.catalogName ? ' placeLabelSmall' : '' }}">
              {{ 'Katalog' | translate }}
            </label>
            <dx-text-box [(value)]="model.catalogName" (onValueChanged)="update()"></dx-text-box>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-3 me-3">
          <div>
            <div class="placeLabel placeLabelSmall text-uppercase">{{ 'Datum' | translate }}:</div>
            <div>{{ model.date | date }}</div>
          </div>
          <div>
            <div class="placeLabel placeLabelSmall text-uppercase">{{ 'Version' | translate }}:</div>
            <div>{{ model.catalogVersion }}</div>
          </div>
        </div>
        <div class="dx-field align-items-center mb-0 me-3">
          <div class="flex-grow-1">{{ 'Kategorien' | translate }}:</div>
          <div class="align-right">{{ model.categoryCount }}</div>
        </div>
        <div class="dx-field align-items-center mb-0 me-3">
          <div class="flex-grow-1">{{ 'Produkte' | translate }}:</div>
          <div class="align-right">{{ model.productCount }}</div>
        </div>
      </div>
    </div>
    <div class="inputWithPlaceHolder w-100">
      <label class="placeLabel{{ model.responsible ? ' placeLabelSmall' : '' }}">
        {{ 'Verantwortlicher' | translate }}
      </label>
      <dx-autocomplete
        [minSearchLength]="0"
        [dataSource]="catalogService.responsibleList"
        [showClearButton]="true"
        [showDropDownButton]="true"
        valueChangeEvent="blur"
        (onValueChanged)="update()"
        [(value)]="model.responsible"
      ></dx-autocomplete>
    </div>

    <div class="inputWithPlaceHolder w-100 pb-0">
      <label class="placeLabel{{ model.note?.trim() ? ' placeLabelSmall' : '' }}">{{ 'Notiz' | translate }}</label>
      <dx-text-area [(value)]="model.note" (onValueChanged)="update()"></dx-text-area>
    </div>

    <div class="d-flex align-items-center justify-content-between px-1 pt-4">
      <div class="d-flex flex-column">
        <small class="placeLabel placeLabelSmall text-uppercase">{{ 'Lieferant' | translate }}:</small>
        <small>{{ model.supplier?.supplierName }}</small>
      </div>
      <img src="images/flags/{{ loginService.getLanguageFlag(model.language?.toLowerCase() ?? 'deu') }}" class="flag" />
    </div>
  </div>

  <hr class="my-0" />

  <div class="d-flex align-items-center justify-content-between px-3 py-4">
    <dx-button-group
      [items]="buttons"
      [elementAttr]="{ class: 'small-button-group' }"
      stylingMode="contained"
      selectionMode="single"
      (onItemClick)="onButtonClick($event)"
    ></dx-button-group>
  </div>
</div>
